import { get } from 'src/axios/post'

export async function performFilter (rows = 5, sortBy = 'priority', page = 1, filter = null, type = null, systemTypes = null) {
  const { status, payload } = await get('v1/inventory/defaults/filter', {
    filter,
    type,
    page,
    rows,
    sortBy,
    sortDirection: 'asc',
    system_types: systemTypes
  })
  if (status === 'success') {
    return {
      count: payload.count,
      list: payload.defaults,
      options: payload.options
    }
  }
  return {
    count: 0,
    list: [],
    options: null
  }
}

export function prefillItem (defaultItem, invItem) {
  if (defaultItem.type) {
    invItem.type = defaultItem.type
  }

  if (defaultItem.selling_unit_price !== 0) {
    invItem.selling_unit_price = defaultItem.selling_unit_price
  }

  if (defaultItem.name) {
    invItem.name = defaultItem.name
  }

  if (defaultItem.code) {
    invItem.code = defaultItem.code
  }

  if (defaultItem.description) {
    invItem.description = defaultItem.description
  }

  if (defaultItem.system_type_id) {
    invItem.system_type_id = defaultItem.system_type_id
  }

  if (defaultItem.metadata.length > 0) {
    invItem.metadata = JSON.parse(JSON.stringify(defaultItem.metadata))
  }
}
